import React from 'react';
import { EMAIL_TONES } from '../types';

const ToneSelector = ({ tone1, tone2, onTone1Change, onTone2Change, className = '' }) => {
  const availableTones = EMAIL_TONES.filter(tone => tone !== tone1);

  return (
    <div className={`space-y-4 ${className}`}>
      <label className="block text-sm font-medium text-gray-700">
        Pick two tones (optional)
      </label>
      
      <div className="space-y-3">
        {/* Primary Tone */}
        <div>
          <label className="block text-xs font-medium text-gray-600 mb-2">
            Primary Tone
          </label>
          <select
            value={tone1}
            onChange={(e) => onTone1Change(e.target.value)}
            className="input-field"
          >
            <option value="">Select a tone...</option>
            {EMAIL_TONES.map((tone) => (
              <option key={tone} value={tone}>
                {tone}
              </option>
            ))}
          </select>
        </div>

        {/* Secondary Tone */}
        <div>
          <label className="block text-xs font-medium text-gray-600 mb-2">
            Secondary Tone
          </label>
          <select
            value={tone2}
            onChange={(e) => onTone2Change(e.target.value)}
            className="input-field"
            disabled={!tone1}
          >
            <option value="">Select a tone...</option>
            {availableTones.map((tone) => (
              <option key={tone} value={tone}>
                {tone}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
};

export default ToneSelector; 